// @ts-check
import _ from 'lodash';

/**
 * @enum {string}
 * @type {Record<string, string>}
 */
export const unitNames = {
  metrePerSecondSquared: 'metrePerSecondSquared',
  centimeterPerSecondSquared: 'centimeterPerSecondSquared',
  gForce: 'gForce',
  radian: 'radian',
  degreeOfArc: 'degreeOfArc',
  minuteOfArc: 'minuteOfArc',
  secondOfArc: 'secondOfArc',
  radianPerSecondSquared: 'radianPerSecondSquared',
  radianPerSecond: 'radianPerSecond',
  degreePerSecond: 'degreePerSecond',
  revolutionPerSecond: 'revolutionPerSecond',
  revolutionPerMinute: 'revolutionPerMinute',
  squareMetre: 'squareMetre',
  squareCentimetre: 'squareCentimetre',
  squareMillimetre: 'squareMillimetre',
  squareKilometre: 'squareKilometre',
  hectare: 'hectare',
  squareFoot: 'squareFoot',
  squareInch: 'squareInch',
  acre: 'acre',
  farad: 'farad',
  millifarad: 'millifarad',
  microfarad: 'microfarad',
  nanofarad: 'nanofarad',
  picofarad: 'picofarad',
  ampere: 'ampere',
  microampere: 'microampere',
  milliampere: 'milliampere',
  bitPerSecond: 'bitPerSecond',
  kibibitPerSecond: 'kibibitPerSecond',
  mebibitPerSecond: 'mebibitPerSecond',
  gibibitPerSecond: 'gibibitPerSecond',
  tebibitPerSecond: 'tebibitPerSecond',
  bytePerSecond: 'bytePerSecond',
  kibibytePerSecond: 'kibibytePerSecond',
  mebibytePerSecond: 'mebibytePerSecond',
  gibibytePerSecond: 'gibibytePerSecond',
  tebibytePerSecond: 'tebibytePerSecond',
  bit: 'bit',
  kibibit: 'kibibit',
  mebibit: 'mebibit',
  gibibit: 'gibibit',
  tebibit: 'tebibit',
  byte: 'byte',
  kibibyte: 'kibibyte',
  mebibyte: 'mebibyte',
  gibibyte: 'gibibyte',
  tebibyte: 'tebibyte',
  kilogramPerCubicMetre: 'kilogramPerCubicMetre',
  gramPerCubicMetre: 'gramPerCubicMetre',
  metre: 'metre',
  centimetre: 'centimetre',
  millimetre: 'millimetre',
  micrometre: 'micrometre',
  nanometre: 'nanometre',
  kilometre: 'kilometre',
  foot: 'foot',
  inch: 'inch',
  mile: 'mile',
  nauticalMile: 'nauticalMile',
  astronomicalUnit: 'astronomicalUnit',
  coloumb: 'coloumb',
  joule: 'joule',
  kiloJoule: 'kiloJoule',
  megaJoule: 'megaJoule',
  gigaJoule: 'gigaJoule',
  electronVolt: 'electronVolt',
  megaelectronVolt: 'megaelectronVolt',
  kilowattHour: 'kilowattHour',
  newton: 'newton',
  pound: 'pound',
  ounce: 'ounce',
  ton: 'ton',
  herz: 'herz',
  kiloherz: 'kiloherz',
  megaherz: 'megaherz',
  gigaherz: 'gigaherz',
  lux: 'lux',
  footcandle: 'footcandle',
  henry: 'henry',
  millihenry: 'millihenry',
  microhenry: 'microhenry',
  turn: 'turn',
  candelaPerSquareMetre: 'candelaPerSquareMetre',
  watt: 'watt',
  microwatt: 'microwatt',
  milliwatt: 'milliwatt',
  kilowatt: 'kilowatt',
  megawatt: 'megawatt',
  gigawatt: 'gigawatt',
  horsepower: 'horsepower',
  kilowattHourPerYear: 'kilowattHourPerYear',
  lumen: 'lumen',
  candela: 'candela',
  weber: 'weber',
  maxwell: 'maxwell',
  tesla: 'tesla',
  kilogram: 'kilogram',
  gram: 'gram',
  milligram: 'milligram',
  microgram: 'microgram',
  tonne: 'tonne',
  slug: 'slug',
  gramPerSecond: 'gramPerSecond',
  kilogramPerSecond: 'kilogramPerSecond',
  gramPerHour: 'gramPerHour',
  kilogramPerHour: 'kilogramPerHour',
  pascal: 'pascal',
  kilopascal: 'kilopascal',
  bar: 'bar',
  millibar: 'millibar',
  millimetresOfMercury: 'millimetresOfMercury',
  poundPerSquareInch: 'poundPerSquareInch',
  inchesOfMercury: 'inchesOfMercury',
  inchesOfWater: 'inchesOfWater',
  percent: 'percent',
  ohm: 'ohm',
  kiloohm: 'kiloohm',
  megaohm: 'megaohm',
  milliOhm: 'milliOhm',
  decibel: 'decibel',
  bel: 'bel',
  kelvin: 'kelvin',
  degreeCelsius: 'degreeCelsius',
  degreeFahrenheit: 'degreeFahrenheit',
  second: 'second',
  millisecond: 'millisecond',
  microsecond: 'microsecond',
  nanosecond: 'nanosecond',
  minute: 'minute',
  hour: 'hour',
  day: 'day',
  year: 'year',
  newtonMetre: 'newtonMetre',
  metrePerSecond: 'metrePerSecond',
  centimetrePerSecond: 'centimetrePerSecond',
  millimetrePerSecond: 'millimetrePerSecond',
  metrePerHour: 'metrePerHour',
  kilometrePerHour: 'kilometrePerHour',
  milePerHour: 'milePerHour',
  knot: 'knot',
  milePerSecond: 'milePerSecond',
  volt: 'volt',
  millivolt: 'millivolt',
  microvolt: 'microvolt',
  kilovolt: 'kilovolt',
  megavolt: 'megavolt',
  cubicMetre: 'cubicMetre',
  cubicCentimetre: 'cubicCentimetre',
  litre: 'litre',
  millilitre: 'millilitre',
  cubicFoot: 'cubicFoot',
  cubicInch: 'cubicInch',
  fluidOunce: 'fluidOunce',
  gallon: 'gallon',
  litrePerSecond: 'litrePerSecond',
  litrePerHour: 'litrePerHour',
  millilitrePerSecond: 'millilitrePerSecond',
  millilitrePerHour: 'millilitrePerHour'
};

/**
 * @constant
 * @type {Record<unitNames, string>}
 */
export const units = {
  [unitNames.metrePerSecondSquared]: 'm/s²',
  [unitNames.centimeterPerSecondSquared]: 'cm/s²',
  [unitNames.gForce]: 'g',
  [unitNames.radian]: 'rad',
  [unitNames.degreeOfArc]: '°',
  [unitNames.minuteOfArc]: '′',
  [unitNames.secondOfArc]: '″',
  [unitNames.radianPerSecondSquared]: 'rad/s²',
  [unitNames.radianPerSecond]: 'rad/s',
  [unitNames.degreePerSecond]: '°/s',
  [unitNames.revolutionPerSecond]: 'rps',
  [unitNames.revolutionPerMinute]: 'rpm',
  [unitNames.squareMetre]: 'm²',
  [unitNames.squareCentimetre]: 'cm²',
  [unitNames.squareMillimetre]: 'mm²',
  [unitNames.squareKilometre]: 'km²',
  [unitNames.hectare]: 'ha',
  [unitNames.squareFoot]: 'ft²',
  [unitNames.squareInch]: 'in²',
  [unitNames.acre]: 'ac',
  [unitNames.farad]: 'F',
  [unitNames.millifarad]: 'mF',
  [unitNames.microfarad]: 'µF',
  [unitNames.nanofarad]: 'nF',
  [unitNames.picofarad]: 'pF',
  [unitNames.ampere]: 'A',
  [unitNames.microampere]: 'µA',
  [unitNames.milliampere]: 'mA',
  [unitNames.bitPerSecond]: 'bps',
  [unitNames.kibibitPerSecond]: 'Kibit/s',
  [unitNames.mebibitPerSecond]: 'Mibit/s',
  [unitNames.gibibitPerSecond]: 'Gibit/s',
  [unitNames.tebibitPerSecond]: 'Tibit/s',
  [unitNames.bytePerSecond]: 'B/s',
  [unitNames.kibibytePerSecond]: 'KiB/s',
  [unitNames.mebibytePerSecond]: 'MiB/s',
  [unitNames.gibibytePerSecond]: 'GiB/s',
  [unitNames.tebibytePerSecond]: 'TiB/s',
  [unitNames.bit]: 'bit',
  [unitNames.kibibit]: 'Kibit',
  [unitNames.mebibit]: 'Mibit',
  [unitNames.gibibit]: 'Gibit',
  [unitNames.tebibit]: 'Tibit',
  [unitNames.byte]: 'B',
  [unitNames.kibibyte]: 'KiB',
  [unitNames.mebibyte]: 'MiB',
  [unitNames.gibibyte]: 'GiB',
  [unitNames.tebibyte]: 'TiB',
  [unitNames.kilogramPerCubicMetre]: 'kg/m³',
  [unitNames.gramPerCubicMetre]: 'g/m³',
  [unitNames.metre]: 'm',
  [unitNames.centimetre]: 'cm',
  [unitNames.millimetre]: 'mm',
  [unitNames.micrometre]: 'µm',
  [unitNames.nanometre]: 'nm',
  [unitNames.kilometre]: 'km',
  [unitNames.foot]: 'ft',
  [unitNames.inch]: 'in',
  [unitNames.mile]: 'mi',
  [unitNames.nauticalMile]: 'nmi',
  [unitNames.astronomicalUnit]: 'au',
  [unitNames.coloumb]: 'C',
  [unitNames.joule]: 'J',
  [unitNames.kiloJoule]: 'kJ',
  [unitNames.megaJoule]: 'MJ',
  [unitNames.gigaJoule]: 'GJ',
  [unitNames.electronVolt]: 'eV',
  [unitNames.megaelectronVolt]: 'MeV',
  [unitNames.kilowattHour]: 'kWh',
  [unitNames.newton]: 'N',
  [unitNames.pound]: 'lb',
  [unitNames.ounce]: 'oz',
  [unitNames.ton]: 't',
  [unitNames.herz]: 'Hz',
  [unitNames.kiloherz]: 'kHz',
  [unitNames.megaherz]: 'MHz',
  [unitNames.gigaherz]: 'GHz',
  [unitNames.lux]: 'lx',
  [unitNames.footcandle]: 'fc',
  [unitNames.henry]: 'H',
  [unitNames.millihenry]: 'mH',
  [unitNames.microhenry]: 'µH',
  [unitNames.turn]: 'turn',
  [unitNames.candelaPerSquareMetre]: 'cd/m²',
  [unitNames.watt]: 'W',
  [unitNames.microwatt]: 'µW',
  [unitNames.milliwatt]: 'mW',
  [unitNames.kilowatt]: 'kW',
  [unitNames.megawatt]: 'MW',
  [unitNames.gigawatt]: 'GW',
  [unitNames.horsepower]: 'hp',
  [unitNames.kilowattHourPerYear]: 'kWh/y',
  [unitNames.lumen]: 'lm',
  [unitNames.candela]: 'cd',
  [unitNames.weber]: 'Wb',
  [unitNames.maxwell]: 'Mx',
  [unitNames.tesla]: 'T',
  [unitNames.kilogram]: 'kg',
  [unitNames.gram]: 'g',
  [unitNames.milligram]: 'mg',
  [unitNames.microgram]: 'µg',
  [unitNames.tonne]: 't',
  [unitNames.slug]: 'slug',
  [unitNames.gramPerSecond]: 'g/s',
  [unitNames.kilogramPerSecond]: 'kg/s',
  [unitNames.gramPerHour]: 'g/h',
  [unitNames.kilogramPerHour]: 'kg/h',
  [unitNames.pascal]: 'Pa',
  [unitNames.kilopascal]: 'kPa',
  [unitNames.bar]: 'bar',
  [unitNames.millibar]: 'mbar',
  [unitNames.millimetresOfMercury]: 'mmHg',
  [unitNames.poundPerSquareInch]: 'psi',
  [unitNames.inchesOfMercury]: 'inHg',
  [unitNames.inchesOfWater]: 'inH₂O',
  [unitNames.percent]: '%',
  [unitNames.ohm]: 'Ω',
  [unitNames.kiloohm]: 'kΩ',
  [unitNames.megaohm]: 'MΩ',
  [unitNames.milliOhm]: 'mΩ',
  [unitNames.decibel]: 'dB',
  [unitNames.bel]: 'B',
  [unitNames.kelvin]: 'K',
  [unitNames.degreeCelsius]: '°C',
  [unitNames.degreeFahrenheit]: '°F',
  [unitNames.second]: 's',
  [unitNames.millisecond]: 'ms',
  [unitNames.microsecond]: 'µs',
  [unitNames.nanosecond]: 'ns',
  [unitNames.minute]: 'min',
  [unitNames.hour]: 'h',
  [unitNames.day]: 'd',
  [unitNames.year]: 'y',
  [unitNames.newtonMetre]: 'Nm',
  [unitNames.metrePerSecond]: 'm/s',
  [unitNames.centimetrePerSecond]: 'cm/s',
  [unitNames.millimetrePerSecond]: 'mm/s',
  [unitNames.metrePerHour]: 'm/h',
  [unitNames.kilometrePerHour]: 'km/h',
  [unitNames.milePerHour]: 'mph',
  [unitNames.knot]: 'kn',
  [unitNames.milePerSecond]: 'mps',
  [unitNames.volt]: 'V',
  [unitNames.millivolt]: 'mV',
  [unitNames.microvolt]: 'µV',
  [unitNames.kilovolt]: 'kV',
  [unitNames.megavolt]: 'MV',
  [unitNames.cubicMetre]: 'm³',
  [unitNames.cubicCentimetre]: 'cm³',
  [unitNames.litre]: 'l',
  [unitNames.millilitre]: 'ml',
  [unitNames.cubicFoot]: 'ft³',
  [unitNames.cubicInch]: 'in³',
  [unitNames.fluidOunce]: 'fl oz',
  [unitNames.gallon]: 'gal',
  [unitNames.litrePerSecond]: 'l/s',
  [unitNames.litrePerHour]: 'l/h',
  [unitNames.millilitrePerSecond]: 'ml/s',
  [unitNames.millilitrePerHour]: 'ml/h'
};

/**
 * @typedef {object} MetricImperial
 * @property {string} metric
 * @property {string} imperial
 */

/**
 * @constant
 * @type {Record<unitNames, MetricImperial>}
 */
export const metricImperialMapping = {
  [unitNames.metrePerSecondSquared]: {
    metric: unitNames.metrePerSecondSquared,
    imperial: unitNames.metrePerSecondSquared
  },
  [unitNames.centimeterPerSecondSquared]: {
    metric: unitNames.centimeterPerSecondSquared,
    imperial: unitNames.centimeterPerSecondSquared
  },
  [unitNames.gForce]: {
    metric: unitNames.gForce,
    imperial: unitNames.gForce
  },
  [unitNames.radian]: {
    metric: unitNames.radian,
    imperial: unitNames.radian
  },
  [unitNames.degreeOfArc]: {
    metric: unitNames.degreeOfArc,
    imperial: unitNames.degreeOfArc
  },
  [unitNames.minuteOfArc]: {
    metric: unitNames.minuteOfArc,
    imperial: unitNames.minuteOfArc
  },
  [unitNames.secondOfArc]: {
    metric: unitNames.secondOfArc,
    imperial: unitNames.secondOfArc
  },
  [unitNames.radianPerSecondSquared]: {
    metric: unitNames.radianPerSecondSquared,
    imperial: unitNames.radianPerSecondSquared
  },
  [unitNames.radianPerSecond]: {
    metric: unitNames.radianPerSecond,
    imperial: unitNames.radianPerSecond
  },
  [unitNames.degreePerSecond]: {
    metric: unitNames.degreePerSecond,
    imperial: unitNames.degreePerSecond
  },
  [unitNames.revolutionPerSecond]: {
    metric: unitNames.revolutionPerSecond,
    imperial: unitNames.revolutionPerSecond
  },
  [unitNames.revolutionPerMinute]: {
    metric: unitNames.revolutionPerMinute,
    imperial: unitNames.revolutionPerMinute
  },
  [unitNames.squareMetre]: {
    metric: unitNames.squareMetre,
    imperial: unitNames.squareFoot
  },
  [unitNames.squareCentimetre]: {
    metric: unitNames.squareCentimetre,
    imperial: unitNames.squareInch
  },
  [unitNames.squareMillimetre]: {
    metric: unitNames.squareMillimetre,
    imperial: unitNames.squareInch
  },
  [unitNames.squareKilometre]: {
    metric: unitNames.squareKilometre,
    imperial: unitNames.squareFoot
  },
  [unitNames.hectare]: {
    metric: unitNames.hectare,
    imperial: unitNames.squareFoot
  },
  [unitNames.squareFoot]: {
    metric: unitNames.squareMetre,
    imperial: unitNames.squareFoot
  },
  [unitNames.squareInch]: {
    metric: unitNames.squareCentimetre,
    imperial: unitNames.squareInch
  },
  [unitNames.acre]: {
    metric: unitNames.acre,
    imperial: unitNames.squareFoot
  },
  [unitNames.farad]: {
    metric: unitNames.farad,
    imperial: unitNames.farad
  },
  [unitNames.millifarad]: {
    metric: unitNames.millifarad,
    imperial: unitNames.millifarad
  },
  [unitNames.microfarad]: {
    metric: unitNames.microfarad,
    imperial: unitNames.microfarad
  },
  [unitNames.nanofarad]: {
    metric: unitNames.nanofarad,
    imperial: unitNames.nanofarad
  },
  [unitNames.picofarad]: {
    metric: unitNames.picofarad,
    imperial: unitNames.picofarad
  },
  [unitNames.ampere]: {
    metric: unitNames.ampere,
    imperial: unitNames.ampere
  },
  [unitNames.microampere]: {
    metric: unitNames.microampere,
    imperial: unitNames.microampere
  },
  [unitNames.milliampere]: {
    metric: unitNames.milliampere,
    imperial: unitNames.milliampere
  },
  [unitNames.bitPerSecond]: {
    metric: unitNames.bitPerSecond,
    imperial: unitNames.bitPerSecond
  },
  [unitNames.kibibitPerSecond]: {
    metric: unitNames.kibibitPerSecond,
    imperial: unitNames.kibibitPerSecond
  },
  [unitNames.mebibitPerSecond]: {
    metric: unitNames.mebibitPerSecond,
    imperial: unitNames.mebibitPerSecond
  },
  [unitNames.gibibitPerSecond]: {
    metric: unitNames.gibibitPerSecond,
    imperial: unitNames.gibibitPerSecond
  },
  [unitNames.tebibitPerSecond]: {
    metric: unitNames.tebibitPerSecond,
    imperial: unitNames.tebibitPerSecond
  },
  [unitNames.bytePerSecond]: {
    metric: unitNames.bytePerSecond,
    imperial: unitNames.bytePerSecond
  },
  [unitNames.kibibytePerSecond]: {
    metric: unitNames.kibibytePerSecond,
    imperial: unitNames.kibibytePerSecond
  },
  [unitNames.mebibytePerSecond]: {
    metric: unitNames.mebibytePerSecond,
    imperial: unitNames.mebibytePerSecond
  },
  [unitNames.gibibytePerSecond]: {
    metric: unitNames.gibibytePerSecond,
    imperial: unitNames.gibibytePerSecond
  },
  [unitNames.tebibytePerSecond]: {
    metric: unitNames.tebibytePerSecond,
    imperial: unitNames.tebibytePerSecond
  },
  [unitNames.bit]: {
    metric: unitNames.bit,
    imperial: unitNames.bit
  },
  [unitNames.kibibit]: {
    metric: unitNames.kibibit,
    imperial: unitNames.kibibit
  },
  [unitNames.mebibit]: {
    metric: unitNames.mebibit,
    imperial: unitNames.mebibit
  },
  [unitNames.gibibit]: {
    metric: unitNames.gibibit,
    imperial: unitNames.gibibit
  },
  [unitNames.tebibit]: {
    metric: unitNames.tebibit,
    imperial: unitNames.tebibit
  },
  [unitNames.byte]: {
    metric: unitNames.byte,
    imperial: unitNames.byte
  },
  [unitNames.kibibyte]: {
    metric: unitNames.kibibyte,
    imperial: unitNames.kibibyte
  },
  [unitNames.mebibyte]: {
    metric: unitNames.mebibyte,
    imperial: unitNames.mebibyte
  },
  [unitNames.gibibyte]: {
    metric: unitNames.gibibyte,
    imperial: unitNames.gibibyte
  },
  [unitNames.tebibyte]: {
    metric: unitNames.tebibyte,
    imperial: unitNames.tebibyte
  },
  [unitNames.kilogramPerCubicMetre]: {
    metric: unitNames.kilogramPerCubicMetre,
    imperial: unitNames.kilogramPerCubicMetre
  },
  [unitNames.gramPerCubicMetre]: {
    metric: unitNames.gramPerCubicMetre,
    imperial: unitNames.gramPerCubicMetre
  },
  [unitNames.metre]: {
    metric: unitNames.metre,
    imperial: unitNames.foot
  },
  [unitNames.centimetre]: {
    metric: unitNames.centimetre,
    imperial: unitNames.inch
  },
  [unitNames.millimetre]: {
    metric: unitNames.millimetre,
    imperial: unitNames.inch
  },
  [unitNames.micrometre]: {
    metric: unitNames.micrometre,
    imperial: unitNames.micrometre
  },
  [unitNames.nanometre]: {
    metric: unitNames.nanometre,
    imperial: unitNames.nanometre
  },
  [unitNames.kilometre]: {
    metric: unitNames.kilometre,
    imperial: unitNames.mile
  },
  [unitNames.foot]: {
    metric: unitNames.metre,
    imperial: unitNames.foot
  },
  [unitNames.inch]: {
    metric: unitNames.centimetre,
    imperial: unitNames.inch
  },
  [unitNames.mile]: {
    metric: unitNames.kilometre,
    imperial: unitNames.mile
  },
  [unitNames.nauticalMile]: {
    metric: unitNames.nauticalMile,
    imperial: unitNames.nauticalMile
  },
  [unitNames.astronomicalUnit]: {
    metric: unitNames.astronomicalUnit,
    imperial: unitNames.astronomicalUnit
  },
  [unitNames.coloumb]: {
    metric: unitNames.coloumb,
    imperial: unitNames.coloumb
  },
  [unitNames.joule]: {
    metric: unitNames.joule,
    imperial: unitNames.joule
  },
  [unitNames.kiloJoule]: {
    metric: unitNames.kiloJoule,
    imperial: unitNames.kiloJoule
  },
  [unitNames.megaJoule]: {
    metric: unitNames.megaJoule,
    imperial: unitNames.megaJoule
  },
  [unitNames.gigaJoule]: {
    metric: unitNames.gigaJoule,
    imperial: unitNames.gigaJoule
  },
  [unitNames.electronVolt]: {
    metric: unitNames.electronVolt,
    imperial: unitNames.electronVolt
  },
  [unitNames.megaelectronVolt]: {
    metric: unitNames.megaelectronVolt,
    imperial: unitNames.megaelectronVolt
  },
  [unitNames.kilowattHour]: {
    metric: unitNames.kilowattHour,
    imperial: unitNames.kilowattHour
  },
  [unitNames.newton]: {
    metric: unitNames.newton,
    imperial: unitNames.newton
  },
  [unitNames.pound]: {
    metric: unitNames.pound,
    imperial: unitNames.pound
  },
  [unitNames.ounce]: {
    metric: unitNames.ounce,
    imperial: unitNames.ounce
  },
  [unitNames.ton]: {
    metric: unitNames.ton,
    imperial: unitNames.ton
  },
  [unitNames.herz]: {
    metric: unitNames.herz,
    imperial: unitNames.herz
  },
  [unitNames.kiloherz]: {
    metric: unitNames.kiloherz,
    imperial: unitNames.kiloherz
  },
  [unitNames.megaherz]: {
    metric: unitNames.megaherz,
    imperial: unitNames.megaherz
  },
  [unitNames.gigaherz]: {
    metric: unitNames.gigaherz,
    imperial: unitNames.gigaherz
  },
  [unitNames.lux]: {
    metric: unitNames.lux,
    imperial: unitNames.lux
  },
  [unitNames.footcandle]: {
    metric: unitNames.footcandle,
    imperial: unitNames.footcandle
  },
  [unitNames.henry]: {
    metric: unitNames.henry,
    imperial: unitNames.henry
  },
  [unitNames.millihenry]: {
    metric: unitNames.millihenry,
    imperial: unitNames.millihenry
  },
  [unitNames.microhenry]: {
    metric: unitNames.microhenry,
    imperial: unitNames.microhenry
  },
  [unitNames.turn]: {
    metric: unitNames.turn,
    imperial: unitNames.turn
  },
  [unitNames.candelaPerSquareMetre]: {
    metric: unitNames.candelaPerSquareMetre,
    imperial: unitNames.candelaPerSquareMetre
  },
  [unitNames.watt]: {
    metric: unitNames.watt,
    imperial: unitNames.watt
  },
  [unitNames.microwatt]: {
    metric: unitNames.microwatt,
    imperial: unitNames.microwatt
  },
  [unitNames.milliwatt]: {
    metric: unitNames.milliwatt,
    imperial: unitNames.milliwatt
  },
  [unitNames.kilowatt]: {
    metric: unitNames.kilowatt,
    imperial: unitNames.kilowatt
  },
  [unitNames.megawatt]: {
    metric: unitNames.megawatt,
    imperial: unitNames.megawatt
  },
  [unitNames.gigawatt]: {
    metric: unitNames.gigawatt,
    imperial: unitNames.gigawatt
  },
  [unitNames.horsepower]: {
    metric: unitNames.horsepower,
    imperial: unitNames.horsepower
  },
  [unitNames.kilowattHourPerYear]: {
    metric: unitNames.kilowattHourPerYear,
    imperial: unitNames.kilowattHourPerYear
  },
  [unitNames.lumen]: {
    metric: unitNames.lumen,
    imperial: unitNames.lumen
  },
  [unitNames.candela]: {
    metric: unitNames.candela,
    imperial: unitNames.candela
  },
  [unitNames.weber]: {
    metric: unitNames.weber,
    imperial: unitNames.weber
  },
  [unitNames.maxwell]: {
    metric: unitNames.maxwell,
    imperial: unitNames.maxwell
  },
  [unitNames.tesla]: {
    metric: unitNames.tesla,
    imperial: unitNames.tesla
  },
  [unitNames.kilogram]: {
    metric: unitNames.kilogram,
    imperial: unitNames.kilogram
  },
  [unitNames.gram]: {
    metric: unitNames.gram,
    imperial: unitNames.gram
  },
  [unitNames.milligram]: {
    metric: unitNames.milligram,
    imperial: unitNames.milligram
  },
  [unitNames.microgram]: {
    metric: unitNames.microgram,
    imperial: unitNames.microgram
  },
  [unitNames.tonne]: {
    metric: unitNames.tonne,
    imperial: unitNames.tonne
  },
  [unitNames.slug]: {
    metric: unitNames.slug,
    imperial: unitNames.slug
  },
  [unitNames.gramPerSecond]: {
    metric: unitNames.gramPerSecond,
    imperial: unitNames.gramPerSecond
  },
  [unitNames.kilogramPerSecond]: {
    metric: unitNames.kilogramPerSecond,
    imperial: unitNames.kilogramPerSecond
  },
  [unitNames.gramPerHour]: {
    metric: unitNames.gramPerHour,
    imperial: unitNames.gramPerHour
  },
  [unitNames.kilogramPerHour]: {
    metric: unitNames.kilogramPerHour,
    imperial: unitNames.kilogramPerHour
  },
  [unitNames.pascal]: {
    metric: unitNames.pascal,
    imperial: unitNames.inchesOfWater
  },
  [unitNames.kilopascal]: {
    metric: unitNames.kilopascal,
    imperial: unitNames.kilopascal
  },
  [unitNames.bar]: {
    metric: unitNames.bar,
    imperial: unitNames.poundPerSquareInch
  },
  [unitNames.millibar]: {
    metric: unitNames.millibar,
    imperial: unitNames.millibar
  },
  [unitNames.millimetresOfMercury]: {
    metric: unitNames.millimetresOfMercury,
    imperial: unitNames.inchesOfMercury
  },
  [unitNames.poundPerSquareInch]: {
    metric: unitNames.bar,
    imperial: unitNames.poundPerSquareInch
  },
  [unitNames.inchesOfMercury]: {
    metric: unitNames.millimetresOfMercury,
    imperial: unitNames.inchesOfMercury
  },
  [unitNames.inchesOfWater]: {
    metric: unitNames.pascal,
    imperial: unitNames.inchesOfWater
  },
  [unitNames.percent]: {
    metric: unitNames.percent,
    imperial: unitNames.percent
  },
  [unitNames.ohm]: {
    metric: unitNames.ohm,
    imperial: unitNames.ohm
  },
  [unitNames.kiloohm]: {
    metric: unitNames.kiloohm,
    imperial: unitNames.kiloohm
  },
  [unitNames.megaohm]: {
    metric: unitNames.megaohm,
    imperial: unitNames.megaohm
  },
  [unitNames.milliOhm]: {
    metric: unitNames.milliOhm,
    imperial: unitNames.milliOhm
  },
  [unitNames.decibel]: {
    metric: unitNames.decibel,
    imperial: unitNames.decibel
  },
  [unitNames.bel]: {
    metric: unitNames.bel,
    imperial: unitNames.bel
  },
  [unitNames.kelvin]: {
    metric: unitNames.kelvin,
    imperial: unitNames.kelvin
  },
  [unitNames.degreeCelsius]: {
    metric: unitNames.degreeCelsius,
    imperial: unitNames.degreeFahrenheit
  },
  [unitNames.degreeFahrenheit]: {
    metric: unitNames.degreeCelsius,
    imperial: unitNames.degreeFahrenheit
  },
  [unitNames.second]: {
    metric: unitNames.second,
    imperial: unitNames.second
  },
  [unitNames.millisecond]: {
    metric: unitNames.millisecond,
    imperial: unitNames.millisecond
  },
  [unitNames.microsecond]: {
    metric: unitNames.microsecond,
    imperial: unitNames.microsecond
  },
  [unitNames.nanosecond]: {
    metric: unitNames.nanosecond,
    imperial: unitNames.nanosecond
  },
  [unitNames.minute]: {
    metric: unitNames.minute,
    imperial: unitNames.minute
  },
  [unitNames.hour]: {
    metric: unitNames.hour,
    imperial: unitNames.hour
  },
  [unitNames.day]: {
    metric: unitNames.day,
    imperial: unitNames.day
  },
  [unitNames.year]: {
    metric: unitNames.year,
    imperial: unitNames.year
  },
  [unitNames.newtonMetre]: {
    metric: unitNames.newtonMetre,
    imperial: unitNames.newtonMetre
  },
  [unitNames.metrePerSecond]: {
    metric: unitNames.metrePerSecond,
    imperial: unitNames.metrePerSecond
  },
  [unitNames.centimetrePerSecond]: {
    metric: unitNames.centimetrePerSecond,
    imperial: unitNames.centimetrePerSecond
  },
  [unitNames.millimetrePerSecond]: {
    metric: unitNames.millimetrePerSecond,
    imperial: unitNames.millimetrePerSecond
  },
  [unitNames.metrePerHour]: {
    metric: unitNames.metrePerHour,
    imperial: unitNames.metrePerHour
  },
  [unitNames.kilometrePerHour]: {
    metric: unitNames.kilometrePerHour,
    imperial: unitNames.milePerHour
  },
  [unitNames.milePerHour]: {
    metric: unitNames.kilometrePerHour,
    imperial: unitNames.milePerHour
  },
  [unitNames.knot]: {
    metric: unitNames.knot,
    imperial: unitNames.knot
  },
  [unitNames.milePerSecond]: {
    metric: unitNames.metrePerSecond,
    imperial: unitNames.milePerSecond
  },
  [unitNames.volt]: {
    metric: unitNames.volt,
    imperial: unitNames.volt
  },
  [unitNames.millivolt]: {
    metric: unitNames.millivolt,
    imperial: unitNames.millivolt
  },
  [unitNames.microvolt]: {
    metric: unitNames.microvolt,
    imperial: unitNames.microvolt
  },
  [unitNames.kilovolt]: {
    metric: unitNames.kilovolt,
    imperial: unitNames.kilovolt
  },
  [unitNames.megavolt]: {
    metric: unitNames.megavolt,
    imperial: unitNames.megavolt
  },
  [unitNames.cubicMetre]: {
    metric: unitNames.cubicMetre,
    imperial: unitNames.cubicFoot
  },
  [unitNames.cubicCentimetre]: {
    metric: unitNames.cubicCentimetre,
    imperial: unitNames.cubicInch
  },
  [unitNames.litre]: {
    metric: unitNames.litre,
    imperial: unitNames.gallon
  },
  [unitNames.millilitre]: {
    metric: unitNames.millilitre,
    imperial: unitNames.fluidOunce
  },
  [unitNames.cubicFoot]: {
    metric: unitNames.cubicMetre,
    imperial: unitNames.cubicFoot
  },
  [unitNames.cubicInch]: {
    metric: unitNames.cubicCentimetre,
    imperial: unitNames.cubicInch
  },
  [unitNames.fluidOunce]: {
    metric: unitNames.litre,
    imperial: unitNames.fluidOunce
  },
  [unitNames.gallon]: {
    metric: unitNames.litre,
    imperial: unitNames.gallon
  },
  [unitNames.litrePerSecond]: {
    metric: unitNames.litrePerSecond,
    imperial: unitNames.litrePerSecond
  },
  [unitNames.litrePerHour]: {
    metric: unitNames.litrePerHour,
    imperial: unitNames.litrePerHour
  },
  [unitNames.millilitrePerSecond]: {
    metric: unitNames.millilitrePerSecond,
    imperial: unitNames.millilitrePerSecond
  },
  [unitNames.millilitrePerHour]: {
    metric: unitNames.millilitrePerHour,
    imperial: unitNames.millilitrePerHour
  }
};

/**
 * This maps value constant in one way, and then there is another map `conversion` that maps both ways
 * NOTE: Do not use this directly. Use `conversion` instead
 * There is a unit test that will fail if the metricToImperial have conversions that does not exist in this.
 * @constant
 * @type {Record<unitNames, Record<unitNames, ((value: number) => number)|number>>}
 */
const internalConversionConstants = {
  [unitNames.metrePerSecondSquared]: {},
  [unitNames.centimeterPerSecondSquared]: {},
  [unitNames.gForce]: {},
  [unitNames.radian]: {},
  [unitNames.degreeOfArc]: {},
  [unitNames.minuteOfArc]: {},
  [unitNames.secondOfArc]: {},
  [unitNames.radianPerSecondSquared]: {},
  [unitNames.radianPerSecond]: {},
  [unitNames.degreePerSecond]: {},
  [unitNames.revolutionPerSecond]: {},
  [unitNames.revolutionPerMinute]: {},
  [unitNames.squareMetre]: {
    [unitNames.squareFoot]: 10.7639
  },
  [unitNames.squareCentimetre]: {
    [unitNames.squareInch]: 0.1550003100006
  },
  [unitNames.squareMillimetre]: {
    [unitNames.squareInch]: 1 / 645.16
  },
  [unitNames.squareKilometre]: {
    [unitNames.squareInch]: 1550003100.006,
    [unitNames.squareFoot]: 10763910.42
  },
  [unitNames.hectare]: {
    [unitNames.squareFoot]: 107639.1041671,
    [unitNames.squareInch]: 15500031.00006
  },
  [unitNames.squareFoot]: {
    [unitNames.acre]: 1 / 43560.0
  },
  [unitNames.squareInch]: { },
  [unitNames.acre]: { },
  [unitNames.farad]: {},
  [unitNames.millifarad]: {},
  [unitNames.microfarad]: {},
  [unitNames.nanofarad]: {},
  [unitNames.picofarad]: {},
  [unitNames.ampere]: {},
  [unitNames.microampere]: {},
  [unitNames.milliampere]: {},
  [unitNames.bitPerSecond]: {},
  [unitNames.kibibitPerSecond]: {},
  [unitNames.mebibitPerSecond]: {},
  [unitNames.gibibitPerSecond]: {},
  [unitNames.tebibitPerSecond]: {},
  [unitNames.bytePerSecond]: { },
  [unitNames.kibibytePerSecond]: { },
  [unitNames.mebibytePerSecond]: { },
  [unitNames.gibibytePerSecond]: { },
  [unitNames.tebibytePerSecond]: { },
  [unitNames.bit]: { },
  [unitNames.kibibit]: { },
  [unitNames.mebibit]: { },
  [unitNames.gibibit]: { },
  [unitNames.tebibit]: { },
  [unitNames.byte]: { },
  [unitNames.kibibyte]: { },
  [unitNames.mebibyte]: { },
  [unitNames.gibibyte]: { },
  [unitNames.tebibyte]: { },
  [unitNames.kilogramPerCubicMetre]: { },
  [unitNames.gramPerCubicMetre]: { },
  [unitNames.metre]: {
    [unitNames.foot]: 3.280839895
  },
  [unitNames.centimetre]: { },
  [unitNames.millimetre]: { },
  [unitNames.micrometre]: { },
  [unitNames.nanometre]: { },
  [unitNames.kilometre]: { },
  [unitNames.foot]: { },
  [unitNames.inch]: {
    [unitNames.centimetre]: 2.54,
    [unitNames.millimetre]: 25.4
  },
  [unitNames.mile]: {
    [unitNames.kilometre]: 1.609344
  },
  [unitNames.nauticalMile]: {
    [unitNames.metre]: 1.852
  },
  [unitNames.astronomicalUnit]: {
    [unitNames.kilometre]: 149597870700
  },
  [unitNames.coloumb]: { },
  [unitNames.joule]: { },
  [unitNames.kiloJoule]: { },
  [unitNames.megaJoule]: { },
  [unitNames.gigaJoule]: { },
  [unitNames.electronVolt]: { },
  [unitNames.megaelectronVolt]: { },
  [unitNames.kilowattHour]: { },
  [unitNames.newton]: { },
  [unitNames.pound]: { },
  [unitNames.ounce]: { },
  [unitNames.ton]: { },
  [unitNames.herz]: { },
  [unitNames.kiloherz]: { },
  [unitNames.megaherz]: { },
  [unitNames.gigaherz]: { },
  [unitNames.lux]: { },
  [unitNames.footcandle]: { },
  [unitNames.henry]: { },
  [unitNames.millihenry]: { },
  [unitNames.microhenry]: { },
  [unitNames.turn]: { },
  [unitNames.candelaPerSquareMetre]: { },
  [unitNames.watt]: { },
  [unitNames.microwatt]: { },
  [unitNames.milliwatt]: { },
  [unitNames.kilowatt]: { },
  [unitNames.megawatt]: { },
  [unitNames.gigawatt]: { },
  [unitNames.horsepower]: { },
  [unitNames.kilowattHourPerYear]: { },
  [unitNames.lumen]: { },
  [unitNames.candela]: { },
  [unitNames.weber]: { },
  [unitNames.maxwell]: { },
  [unitNames.tesla]: { },
  [unitNames.kilogram]: { },
  [unitNames.gram]: { },
  [unitNames.milligram]: { },
  [unitNames.microgram]: { },
  [unitNames.tonne]: { },
  [unitNames.slug]: { },
  [unitNames.gramPerSecond]: { },
  [unitNames.kilogramPerSecond]: { },
  [unitNames.gramPerHour]: { },
  [unitNames.kilogramPerHour]: { },
  [unitNames.pascal]: { },
  [unitNames.kilopascal]: { },
  [unitNames.bar]: {
    [unitNames.poundPerSquareInch]: 14.503773773022
  },
  [unitNames.millibar]: {
    [unitNames.poundPerSquareInch]: 0.014503773773022
  },
  [unitNames.millimetresOfMercury]: {
    [unitNames.inchesOfMercury]: 0.03937
  },
  [unitNames.poundPerSquareInch]: { },
  [unitNames.inchesOfMercury]: { },
  [unitNames.inchesOfWater]: {
    [unitNames.pascal]: 249.08890833333
  },
  [unitNames.percent]: { },
  [unitNames.ohm]: { },
  [unitNames.kiloohm]: { },
  [unitNames.megaohm]: { },
  [unitNames.milliOhm]: { },
  [unitNames.decibel]: { },
  [unitNames.bel]: { },
  [unitNames.kelvin]: { },
  [unitNames.degreeCelsius]: {
    [unitNames.degreeFahrenheit]: (/** @type {number} */value) => value * 1.8 + 32
  },
  [unitNames.degreeFahrenheit]: {
    [unitNames.degreeCelsius]: (/** @type {number} */value) => (value - 32) / 1.8
  },
  [unitNames.second]: { },
  [unitNames.millisecond]: { },
  [unitNames.microsecond]: { },
  [unitNames.nanosecond]: { },
  [unitNames.minute]: { },
  [unitNames.hour]: { },
  [unitNames.day]: { },
  [unitNames.year]: { },
  [unitNames.newtonMetre]: { },
  [unitNames.metrePerSecond]: {
    [unitNames.milePerHour]: 2.23694,
    [unitNames.milePerSecond]: 0.000621371
  },
  [unitNames.centimetrePerSecond]: {
    [unitNames.milePerHour]: 0.0223694
  },
  [unitNames.millimetrePerSecond]: {
    [unitNames.milePerHour]: 0.00223694
  },
  [unitNames.metrePerHour]: {
    [unitNames.milePerHour]: 0.000621371
  },
  [unitNames.kilometrePerHour]: {
    [unitNames.milePerHour]: 0.621371
  },
  [unitNames.milePerHour]: { },
  [unitNames.knot]: {
    [unitNames.metrePerSecond]: 0.514444
  },
  [unitNames.milePerSecond]: { },
  [unitNames.volt]: { },
  [unitNames.millivolt]: { },
  [unitNames.microvolt]: { },
  [unitNames.kilovolt]: { },
  [unitNames.megavolt]: { },
  [unitNames.cubicMetre]: {
    [unitNames.cubicFoot]: 35.3147
  },
  [unitNames.cubicCentimetre]: {
    [unitNames.cubicInch]: 0.0610237441
  },
  [unitNames.litre]: {
    [unitNames.gallon]: 0.219969,
    [unitNames.fluidOunce]: 335.195065
  },
  [unitNames.millilitre]: {
    [unitNames.ounce]: 0.0351951
  },
  [unitNames.cubicFoot]: { },
  [unitNames.cubicInch]: {},
  [unitNames.fluidOunce]: {
    [unitNames.millilitre]: 28.4131
  },
  [unitNames.gallon]: { },
  [unitNames.litrePerSecond]: {
    [unitNames.gallon]: 0.219969
  },
  [unitNames.litrePerHour]: { },
  [unitNames.millilitrePerSecond]: { },
  [unitNames.millilitrePerHour]: { }
};

/**
 * @constant
 */
export const conversion = _.reduce(internalConversionConstants, (result, value, key) => {
  const newValue = _.reduce(value, (internalResult, internalValue, internalKey) => {
    if (_.isNumber(internalValue)) {
      internalResult[internalKey] = internalValue;
      if (result[internalKey] != null && result[internalKey][key] != null) {
        throw new Error(`Conversion already exists for ${internalKey} to ${key}. Make sure it only have one way conversion`);
      }
      // Also add the reverse conversion
      result[internalKey] = { ...(result[internalKey] ?? {}), [key]: 1 / internalValue };
    } else if (_.isFunction(internalValue)) {
      // Keep functions
      internalResult[internalKey] = internalValue;
    }
    return internalResult;
  }, {});
  result[key] = { ...(result[key] ?? {}), ...newValue };
  return result;
}, {});
